import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Access, User } from '../../../auth/user.model';
import { AccessService } from '../../access.service';
import { AuthService } from '../../../auth/auth.service';
import { UIService } from '../../../shared/ui.service';

@Component({
  selector: 'app-access-details',
  templateUrl: './access-details.component.html',
  styleUrls: ['./access-details.component.css']
})
export class AccessDetailsComponent implements OnInit {

  user: User;
  access: Access;
  currentPermissionId:number = -1;

  constructor(
    public dialogRef: MatDialogRef<AccessDetailsComponent>,
    private authentication: AuthService,
    private accessService: AccessService,
     private uiService: UIService,
     @Inject(MAT_DIALOG_DATA) public accessId: number
  ) { }

  ngOnInit() {
    this.user = this.authentication.getUser();
    this.accessService.getAccessById(this.user.token, this.accessId).subscribe((result: Access) => {
      this.access = result;
      this.currentPermissionId = this.access.permissions[0].id;
    });
  }

  changePermission(event: Event) {
    this.accessService.updateAccess(this.user.token, this.access, this.currentPermissionId ).subscribe((response: Access) => {
        this.uiService.loadingStateChanged.next(false);
        this.dialogRef.close();
      });

  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}
